<template>
  <div>
    <h1 class="text-center">
      {{ $t('welcome') }}
    </h1>
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h3 class="mb-0">
              {{ $t('resetYourPassword') }}
            </h3>
          </div>
          <div class="card-body">
            <b-alert v-model="showError" type="danger" dismissible>
              <p v-for="(error, i) in globalErrors" :key="i">
                {{ $t('resetPassword.errors.' + error) }}
              </p>
            </b-alert>
            <div v-if="isValidCode === false" class="alert alert-danger">
              <p><strong>{{ $t('resetPassword.invalidCode1') }}</strong></p>
              <p>{{ $t('resetPassword.invalidCode2') }}</p>
              <p>{{ $t('resetPassword.invalidCode3') }}</p>
              <p>
                <router-link :to="{name: 'reset-password'}">
                  {{ $t('resetPassword.invalidCode4') }}
                </router-link>
              </p>
            </div>
            <form v-if="true" @submit.prevent="onSubmit">
              <p>
                {{ $t('resetPassword.resetInstructions') }}
              </p>
              <div class="form-group">
                <label> {{ $t('resetPassword.newPassword') }}:</label>
                <password
                  v-model="password"
                  :badge="false"
                  name="password"
                  :placeholder="$t('resetPassword.placeholder')"
                  defaultClass="form-control"
                  @score="updatedScore"
                  :toggle="true"
                />
                <ul v-if="showPasswordHints" class="error-list">
                  <li v-if="passwordHints.warning">{{ passwordHints.warning }}</li>
                  <li v-for="suggestion in passwordHints.suggestions">{{ suggestion }}</li>
                </ul>
              </div>
              <div class="form-group">
                <label>{{ $t('resetPassword.confirmPassword') }}:</label>
                <password
                  id="confirmPass"
                  v-model="confirmPassword"
                  :badge="false"
                  name="password2"
                  :placeholder="$t('resetPassword.confirmPlaceholder')"
                  defaultClass="form-control"
                  strengthMeterClass="d-none"
                  :toggle="true"
                />
                <ul v-if="showMatchError" class="error-list">
                  <li>{{ $t('resetPassword.errors.passwordsMustBeSame') }}</li>
                </ul>
              </div>
              <div class="form-group" v-if="!showConfirmation">
                <input
                  type="submit"
                  class="btn btn-primary"
                  :value="$t('requestReset')"
                  :disabled="!isReady"
                >
                <i
                  v-if="isReady"
                  class="fa fa-check"
                  style="color: green; font-size: 1.5em; vertical-align: middle; padding-left: 15px;"
                />
              </div>
              <b-alert v-else variant="success">
                {{ $t('resetPassword.passwordResetSuccess') }}
              </b-alert>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { BAlert } from "bootstrap-vue";
  import Password from 'vue-password-strength-meter';
  import zxcvbn from "zxcvbn";

  export default {
    components: {
      BAlert,
      Password,
    },
    props: {
      'validateCode': {
        type: String,
        required: true,
      }
    },
    data() {
      return {
        password: '',
        confirmPassword: '',
        showError: false,
        isValidCode: null,
        globalErrors: [],
        passwordStrength: null,
        showConfirmation: false,
      }
    },
    computed: {
      strength() {
        return this.passwordStrength || 0;
      },
      passwordsMatch() {
        return this.password === this.confirmPassword;
      },
      showMatchError() {
        return !!this.password && !!this.confirmPassword && !this.passwordsMatch;
      },
      isReady() {
        return this.passwordsMatch && this.passwordStrength >= 3;
      },
      passwordHints() {
        return zxcvbn(this.password).feedback;
      },
      showPasswordHints() {
        return !!this.password
          && this.passwordHints.suggestions.length > 0;
      }
    },
    async mounted() {
      this.$store.commit('SET_LOADING', true);
      this.isValidCode = await this.$store.dispatch('VALIDATE_RESET_CODE', this.validateCode);
      this.$store.commit('SET_LOADING', false);
    },
    methods: {
      updatedScore(score) {
        this.passwordStrength = score;
      },
      async onSubmit() {
        this.$store.commit('SET_LOADING', true);
        try {
          await this.$store.dispatch(
            'COMPLETE_PASSWORD_RESET',
            {
              code: this.validateCode,
              password: this.password
            }
          );

          this.showConfirmation = true;
          this.$store.commit('SET_LOADING', false);

          setTimeout(() => {
            // https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
            this.$router.push({name: 'home'}).catch(e => {
            });
          }, 5000);
        } catch (err) {
          if (err.response && err.response.body) {
            if (err.response.body.errors && err.response.body.errors.length) {
              this.globalErrors = err.response.body.errors;
              this.showError = true;
            }
          }
          this.$store.commit('SET_LOADING', false);
        }
      }
    }
  }
</script>

<style scoped>
  .Password {
    max-width: none;
    margin: 0 0;
  }

  /*
  These (>>>) are deep selectors which apply to subcomponents.
  https://vue-loader.vuejs.org/guide/scoped-css.html#deep-selectors
  */
  .Password >>> .Password__strength-meter:before {
    left: 20%;
    width: 20%;
  }

  .Password >>> .Password__strength-meter:after {
    right: 20%;
    width: 20%;
  }
</style>
